define(function(require, exports) {
    
        'use strict';
    
        var ACTUAL_EVENET="zineoneClickEvent";
    
        function EventManager() {

            var publish=function(eventName,data){

                gadgets.pubsub.publish(ACTUAL_EVENET,{
                    eventName:eventName,
                    data:data
                });
            }
            
            var subscribe=function(eventName,callBack){
                gadgets.pubsub.subscribe(eventName,callBack);
            }
            return {
                publish: publish,
                subscribe: subscribe,
             }
    
        }
    
        exports.EventManager = EventManager;
    
    });


// WEBPACK FOOTER //
// ./src/feature-hdfc-navigation/scripts/service/EventManager.js